import ar from './ar.json'
import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import ja from './ja.json'
import ko from './ko.json'
import pt from './pt.json'

export default {
  ar,
  de,
  en,
  es,
  fr,
  ja,
  ko,
  pt,
  nb: {},
  nn: {},
  no: {},
  sv: {},
  'en-NZ': {},
}
